import { NgModule } from "@angular/core";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { CacheInterceptor } from "./cache.interceptor";
import { CacheUriRegistrationService } from "./cache-uri-registration-service";
import { RequestCacheService } from "./request-cache-service";

@NgModule({
  providers: [
    CacheUriRegistrationService,
    RequestCacheService,
    { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
  ],
})
export class RequestCacheModule {
  constructor() {
  }
}
